import { all } from "axios";
import { use } from "echarts";
import { text } from "stream/consumers";
import { feedback } from "/@/api/chat";
import { title } from "process";

export default {
	category: {
		placeholder: '输入关键词 ，如',
		edit: '编辑',
		delete: '删除',
		noResult: '搜索无结果',
		noCategory: '指令走丢了',
		changeKey: '换个关键词试试',
		changeKeyCategory: '前往推荐中心',
		deleteTitle: '温馨提示',
		deleteContent: '您确定要删除该指令吗？',
		deleteConfirm: '确定',
		deleteCancel: '取消',
		deleteSuccess: '删除成功',
		add: '创建指令',
		name: '指令',
		noSearch: '您还没有创建过智能体，点击按钮快速创建',
		noSearch1: '您还没有创建过智能体，请去PC端创建',
		editName: '重命名对话',
		info: '对话记录移动到这里啦~',
		info1: '我知道了',
		info2: '已保存修改',
		info3: '已删除',
		editName1: '重命名作品',
		deepThink: '深度思考',
		tip: '解决推理问题',
		tipHead: '深度思考已上线',
		tipMes: '擅长深度思考解决推理类问题',
		infoToast: '深度思考不支持上传文件',
		infoToast1: '继续切换已上传文件将被删除',
	},

	center: {
		placeHolder: '请输入您的问题，Enter发送，Shift Enter换行',
		continueText: '答案过长，是否',
		continueButton: '继续生成',
		chatLog: '历史记录',
		chatProduction: '作品',
		chatDia: '对话',
		hello: '您好，我是雅意·YaYi',
		answer: '你可以对我说：',
		change: '换一批',
		stop: '停止生成',
		reopen: '即将为你打开全新对话，一起探索新话题',
		deepThinkOpen: '本次推理已结束,即将为你打开全新对话',
		sensitiveTitle: '系统检测到您触发了安全审核机制，将自动为您创建新的会话',
		reference: '内容为AI生成仅供参考',
		role: '智能体',
		YaYi: '雅意',
		detail: '详情',
		callPlugin: '调用插件',
		pluginTime: '插件耗时',
		pluginResult: '插件结果',
		edit: '编辑',
		copy: '复制',
		share: '分享',
		alreadyCopy: '已复制',
		regenerate: '重新生成',
		tip: '内容均由人工智能模型生成，不代表我们的态度或观点，请仔细甄别',
		submit: '提交',
		up: '赞',
		down: '踩',
		alreadyDown: '已踩',
		example: '示例代码',
		play: '播放',
		alsoAsk: '你还可以问：',
		changeQuestion: '换一换',
		copyCode: '复制代码',
		clickUpSuccess: '点赞成功',
		clickDownSuccess: '点踩成功',
		reportSuccess: '已提交举报，感谢您的反馈',
		copySuccess: '复制成功',
		cannotUp: '当前回答无法点赞',
		cannotDown: '当前回答无法点踩',
		generateAnswer: '{name}我正在思考，这可能需要点时间...',
		generateAnswerHK: 'D2 正在为您生成答案...',
		themeChange: '主题切换',
		collapse: '收起',
		expand: '展开',
		hiddenLines: '已隐藏 {n} 行',
		waitForComplete: '请等待生成完成',
		source: '来源',
		refer: '参考',
		startConnection: '建立连接中',
		endConnection: '关闭连接中',
		startRecord: '开始录音',
		recording: '录音中',
		assistantPlaceholder: '“/”唤醒指令助手，您还可以直接粘贴链接试试',
		assistantPlaceholder1: '发送消息给{name}，Enter发送，Shift+Enter换行',
		textPlaceHolder: '有什么问题尽管问我',
		selectedContent: '已选中内容：',
		unfold: '展开',
		doWhat: '要对这句话做点什么呢？',
		uploadFinish: '上传完成',
		pluginTip: '暂无插件',
		confirmParse: '确认解析',
		pageReadAnalyse: '网页阅读分析',
		// pageReadAnalyseTip: '根据网页精准解析回答，不超过128k',
		pageReadAnalyseTip: '根据网页精准解析回答，不超过20万字',
		pageReadPlaceholder: '请输入URL',
		imgAnalyse: '图像智能解析',
		imgTip: '支持jpg、jpeg、png图片',
		docReadAnalyse: '文档阅读分析',
		// docReadAnalyseTip: '支持解析doc、docx、pdf、txt文件，不超过128k',
		docReadAnalyseTip: '支持解析doc、docx、pdf、txt文件，不超过20万字',
		parseError: '解析失败：内容过长',
		allowFileType: '只允许上传文件的格式：',
		fileSizeMoreThan10: '文件：{name}超出了20M，请处理后再上传',
		fileSizeMoreThan1024: '文件：{name}超出了1GB，请处理后再上传',
		promptCheck: 'Prompt查看',
		addConversation: '新建对话',
		tryExample: '可以试试以下案例',
		just: '刚刚',
		seconds: '秒',
		minutes: '分',
		hours: '小时',
		days: '天',
		ago: '前',
		ready: '正在搜索网络资料...',
		running: '正在阅读网络资料...',
		pageSummary: '读取网页并总结',
		pageKBSummary: '读取知识文件并总结',
		bingSearch: '联网查询：',
		fileSearch: '知识查询：',
		onLineSearchTitle: '查询{name}次，共检索到{num}个相关文件，点击查看详情',
		toastTitle: '当前暂不支持同时上传图片和文档',
		toastTitle1: '暂不支持上传图片并添加网页',
		toastContent: '如继续上传图片将覆盖已上传文件',
		toastContent1: '如继续上传文件将覆盖已上传图片',
		okText: '覆盖并上传',
		about: '约{num}字',
		repeatInfo: '{url}重复,请删除重复的URL',
		existInfo: '{url}已解析,请重新输入',
		info: '最多解析数量为10条',
		info1: '文件数量不能超过10个',
		info2: '图片数量不能超过3个',
		info3:'最多上传一个文件',
		fileValueInfo: '链接地址不能为空',
		wordsLimit: '字数超出限制,请删减后再发送',
		sendMessage: '请输入问题后再发送',
		errMessage: '存在解析异常文件，请处理后再发送',
		failMessage: '解析失败',
		failMessage1: '涉及敏感',
		failMessage2: '上传失败',
		loadingStatus: '正在联网检索中',
		name: '子问题{num}：',
		allSelect: '全选',
		preview: '预览',
		shareChat: '分享对话',
		copyUrl: '复制分享链接',
		copySuccess1: '已复制链接，快去分享吧~',
		noSelect: '请先选择需要分享的消息',
		shareInfo: '对话内容由 AI 自动生成，不代表官方的态度或观点',
		goToChat: '进入雅意，发现更多内容',
		wordsCountTip: '超出字数限制，请基于前20万字资料进行问答。',
		// linkInfo:"【磐石】这是我与{name}的聊天对话，你也来试试吧~【点击链接直接打开 或者 复制内容至磐石APP直接打开】",
		// linkInfo2: "【磐石】这是我与AI搜索的聊天对话，你也来试试吧~【点击链接直接打开 或者 复制内容至磐石APP直接打开】",
		// linkAgentInfo:"【磐石】这是我分享的智能体「{name}」，你也来试试吧~ 【点击链接直接打开 或者 复制内容至磐石APP直接打开】",
		linkInfo: '【雅意】这是我与{name}的聊天对话，你也来试试吧~【点击链接直接打开】',
		linkInfo2: '【雅意】这是我与AI搜索的聊天对话，你也来试试吧~【点击链接直接打开】',
		linkInfo3: '【雅意】这是我生成的长文「{name}」，你也来试试吧~【点击链接直接打开】',
		linkAgentInfo: '【雅意】这是我分享的智能体「{name}」，你也来试试吧~ 【点击链接直接打开】',
		shareMessage: '扫码下载雅意APP',
		pluginsResult: '暂无插件',
		linkText: '点击链接查看和YAYI的对话',
		noData: '该会话暂时无法查看',
		chatIng: '当前对话正在进行中',
		uploadTitle: '文件拖拽到此即可上传',
		uploadInfo: '支持上传类型为：doc、docx、pdf、txt、md、jpg、jpeg、png',
		uploadInfo1: '支持上传文件（最多10个文件，每个20MB）',
		uploadInfo5: '支持上传文件（最多1个文件，每个20MB）',
		uploadInfo2: '接受 {name} 等',
		uploadInfo4: '接受 .pdf/.doc/.docx/.xls/.xlsx/.ppt/.pptx/.txt/.png/.jpg',
		uploadInfo6: '接受 .pdf/.docx/.xls/.xlsx/.pptx/.txt/.png/.jpg/.csv/.md/.epub/.wps',
		img: '图片',
		uploadInfo3: '上传的文件包含暂未支持的文件格式，请转换文件格式后重试。支持的文件格式：{name}',
		loading: '上传中',
		pluginInfo1: '已开启插件，雅意会智能调用插件解决问题',
		pluginInfo2: '已关闭插件，问题将由雅意大模型直接回答',
		pluginInfo3: '上传文件或网站后，已自动关闭插件',
		plugin: '插件',
		new: '最近',
		collect: '收藏',
		noCollect: '暂无收藏记录',
		collectChat: '收藏对话',
		collected: '已收藏',
		noKnowList: '暂无知识库',
		noKnowListInfo: '请先前往知识库创建后添加',
		resultInfo: '已运行代码解答',
		resultIng: '正在分析并生成代码',
		outlineInfo: '已生成大纲',
		outlineIng: '正在生成大纲',
		thinkDone: '已思考',
		deepthinkInfo: '已完成思考',
		deepthinkIng: '正在思考',
		deepthinkIng1: '正在生成...',

		result: '结果',
		searchWeb: '搜索网页',
		bottomInfo: '内容由AI生成，仅供参考和借鉴',
		wenge: '中科闻歌',
		agentCenter: '智能体中心',
		linkInfo1: '访问雅意开源社区',
		nameYayi: '雅意',
		like: '点赞',
		nolike: '点踩',
		preViewInfo: '暂不支持预览',
		loadingPreViewInfo: '文件上传中，不支持预览',
		loadingPreViewInfo1: '文件解析中，不支持预览',
		failPreViewInfo: '文件上传失败，不支持预览',
		infoMessage: '（上传超时，已截取部分内容）',
		aiSearchPlace: '打算深入探究的内容、希望了解的问题，都可以发给我~',
		searchPlace: '请输入问题...',
		from: '来自',
		share1: '的分享',
		chatAgain: '接着聊',
		deleteInfo: '该智能体已被删除，无法进行对话',
		deleteInfo1: '该智能体已被发布者删除，无法进行对话',
		deleteInfo2: '该智能体已下线，无法进行对话',
		referenceSources: '参考来源',
		ask: '追问',
		writerInfo: '使用雅意writer专业AI写作',
		editTheQuestion1: '您已经终止本次搜索，可',
		editTheQuestion2: '编辑问题',
		editTheQuestion3: '后重新发起。',
		stageSteps1: '问题剖析',
		stageSteps2: '资料检索',
		stageSteps3: '答案总结',
		answerNodata1: '您所选的来源未检索到相关信息，可',
		answerNodata2: '编辑问题',
		answerNodata3: '或',
		answerNodata4: '选择其他来源',
		answerNodata5: '后重新发起搜索',
		resultTotal: '探索已完成',
		textTruncation: '文件内容过长，已截取部分内容',
		tipName: '名称不能为空',
		selectLabel: '请选择举报类型',
		historyPlace: '搜索对话标题...',
		historyPlace1: '搜索作品标题...',
		historyPlace2: '搜索历史记录...',
		you: '你',
		clear: '清空',
		time: '时间',
		noproductionInfo: '您还没有生成过作品',
		noproductionInfo1: '期待您的精彩内容',
		name1: '长文写作',
		resultInfo1: '生成的结果可以在',
		record: '记录-作品',
		check: '中查看',
		longWrite: '长文',
		fail: '生成失败',
		loadingInfo: '生成中',
		pendingInfo: '排队中',
		editName: '重命名',
		public: '发布',
		checkHistory: '在对话中查看',
		noLink: '链接已失效',
		proDetail: '作品详情',
		infoSend: '链接已失效，无法进行对话',
		historyTitle: '研究',
		parsing: '正在解析',
		fileTypeError: '请上传正确的格式',
		onlyPdfLiterature: '当前仅支持格式为.pdf/.docx/.doc的文献，请重新上传',
		posterLiterature: '当前仅支持格式为.pdf/.docx/.doc/.txt/.md的文献，请重新上传',
		confirm:'等待确认',
		playback: '查看回放'
		
	},
	record: {
		record: '记录',
		recordTip: '对话历史记录',
		assistant: '助手',
		assistantTip: '虚拟数字人播报',
		noMore: '暂无更多',
		confirm: '确认',
		deleteChat: '确认删除此会话？',
		noChatRecord: '暂无对话记录',
		yayiAssistant: 'YAYI助手',
		chatName: '对话名称不能为空',
		startSound: '开启声音',
		closeSound: '关闭声音',
		noChatRecord1: '没有搜到哦，去问问雅意吧！',
		btn: '开启新对话',
		loading: '数据加载中...',
		nodata: '您还没有生成过作品',
		nodata1: '期待您的精彩内容',
		deleteChat1: '确认删除此作品？',
	},
	prompt: {
		exit: '退出',
		cancel: '取消',
		confirmExit: '确认退出吗？',
		exitTips: '退出后不保存当前内容',
		createSkill: '新建指令',
		editSkill: '编辑指令',
		basicSkill: '基础指令',
		skillName: '指令名称',
		skillNamePlaceholder: '请输入指令名称',
		placeholder: '请输入',
		placeholderSelect: '请选择',
		category: '所属分类',
		skillBrief: '指令简介',
		templatePlaceholder: '请输入模板内容',
		role: '背景角色',
		rolePlaceholder:
			'请输入身份，如：金融专家，具备10年的行业经验，是个资深的金融领域专家，具备金融领域实地分析和总结推理的能力，可以做金融、股市、媒体、互联网等新兴产业的专业分析。',
		recommendedQuestions: 'Prompt',
		promptEmptyPlaceholder: '请输入Prompt',
		promptPlaceholder:
			"请输入模版内容，插值参数通过大括号{'{}'}中填写定义，支持英文、数字、下划线，且不能是纯数字，长度2-30。示例：文章内容：{'{'} article{'}'} ，请以{'{'}number{'}'}字数进行总结",
		variable: '变量',
		variablePlaceholder: '请输入变量示例值',
		noData: '暂无数据',
		creativity: '创造力',
		save: '保存',
		debug: '调试',
		promptPreview: 'Prompt 预览',
		promptPreviewTip: '左侧输入Prompt即可实时预览',
		run: '运行',
		result: '结果',
		time: '耗时',
		takeToken: '花费Token',
		generateResult: '结果生成中...',
		variableName: '变量名',
		type: '类型',
		example: '示例',
		string: '字符串',
		newSkills: '创建指令',
		editSkills: '编辑指令',
		examples: '应用示例Prompt',
		skillNameFirstTip: '请先输入指令名称',
	},
	store: {
		bgRoleName: '雅意',
		// errorText: '网络开小差去了，请稍后再戳戳我',
		errorText: '很抱歉，服务太火爆了，请您稍后试试吧！',
		errorText1: '网络连接似乎有点问题，检查您的网络设置后再次尝试。',
		errorText2: '当前服务负载较高，请稍后试试。',
		stopGenerate: '停止生成',
		loginInvalidation: '该设备登录已失效',
		loginAgainContent: '请重新登录',
		loginAgainBtn: '重新登录',
		caiFormTitle: '您的反馈对我们意义重大，您认为',
		caiFormPlaceholder: '您认为更理想的答案是什么？',
		zanFormTitle: '您的反馈对我们意义重大，您认为',
		zanFormPlaceholder: '给您带来的惊喜有哪些？',
		report: '举报',
		type: '举报问题类型',
		desc: '问题描述',
		placeHold: '请输入内容',
	},
	temperature: {
		title: '创造力是指模型在生成答案时的“温度（temperature）”参数。这个参数可以影响大模型的回答自由度。',
		lowTitle: '创造力较低时',
		lowDescribe: '模型会更加谨慎，避免产生过于激进或冒险的答案。',
		hightTitle: '创造力较高时',
		hightDescribe: '模型会更加开放，敢于尝试新的、不寻常的答案。',
		temperatureType1: '严谨',
		temperatureType2: '均衡',
		temperatureType3: '均衡',
	},
	role: {
		edit: '编辑',
		delete: '删除',
		add: '新增',
		deleteCancel: '取消',
		cancel: '取消',
		neverCrate: '您还未创建过指令',
		createImmediate: '立即创建',
		debug: '调试',
		variableName: '变量名',
		string: '字符串',
		type: '类型',
		example: '示例',
		default: '默认值',
		save: '保存',
		confirmExit: '确认退出吗？',
		exitTips: '退出后不保存当前内容',
		exit: '退出',
		createAssistant: '创建智能体',
		roleAssistant: '智能体',
		roleAssistantDes:
			'你可以通过创建智能体的方式创建领域专家助手，设定对话智能体的身份信息，比如智能体专业度、回答风格、询问策略等关键信息，使其具备快速学习和适应新角色的能力，提供全面且专业的服务。',
		skillAssistant: '指令',
		skillAssistantDes:
			'你可以通过创建指令的方式设置大模型的回复边界、标准、要求等条件，确保大模型输出的答案效果可控，基于大模型生成能力磐石可以提供文章摘要生成、翻译、抽取、多模态内容理解与生成的指令服务。',
		exitAssistant: '退出智能体',
		helloRole: '你好，我是',
		deleteDes: '若删除此智能体，与之相关的对话记录都会被删除，且不可恢复。',
		createRoleAssistant: '创建智能体',
		EditRoleAssistant: '编辑智能体',
		avatar: '头像',
		roleName: '名称',
		entryRoleName: '请输入智能体名称',
		placeholderRoleName: '面试官、法律专家',
		roleNameTip: '设定的智能体昵称',
		roleDesc: '简介',
		entryRoleDesc: '请输入智能体简介',
		placeholderRoleDesc: '我是你的媒体助手小明，可以帮助你撰写实时资讯等新闻稿件，24小时为你服务',
		roleDescTip: '描述该智能体的介绍话术',
		AIRecommend: 'AI生成推荐',
		openingRemarks: '开场白',
		entryOpeningRemarks: '请输入对话开场白',
		placeholderOpeningRemarks: '你好，我是你的客服FAQ助手，你可以这样问我',
		openingRemarksTip: '打开智能体对话窗口时，智能体的第一句话',
		systemPreset: '身份设定',
		entrySystemPreset: '请输入身份设定',
		placeholderSystemPreset:
			'你是一个专业的面试官，人类是你的候选人，人类会发送需要面试的岗位名称，然后你会根据岗位，与人类通过多轮问答的形式展开面试。\n要求：\n1. 你与候选人需要用中文交流；\n2. 你每次只需要向面试者提问一个问题；\n3. 当你与候选人问答六个轮次后（即候选人回答完第6个问题后）面试结束，你需要根据候选人的回答情况给出面试评价。',
		systemPresetTip: '设定身份信息后，系统会按照设定的身份快速学习并适应新智能体。系统智能体身份描述越精准，智能体越专业',
		questionItemExp: '提问示例',
		questionItemExpTip: '设定智能体后，智能体的推荐问题',
		expTitle: '示例标题',
		PromptRecommend: 'Prompt推荐',
		input: '请输入', // input:"Please enter",
		promptPlaceholder:
			"请输入模版内容，插值参数通过大括号{'{}'}中填写定义，支持英文、数字、下划线，且不能是纯数字，长度2-30。示例：文章内容：{'{'} article{'}'} ，请以{'{'}number{'}'}字数进行总结",
		plugins: '默认插件',
		debugTitle: '调试与预览',
		debugTip: '完善左侧的智能体基本信息后，即可运行调试',
		expQuestion: '示例问题',
		examplePrompt: '示例Prompt',
		addMsg: '添加成功',
		editMsg: '编辑成功',
		edmitMsg: '提交失败',
		configDelete: '确认删除智能体',
		configRemove: '确认移除智能体',
		talk: '你可以与我对话了~',
		searchPlaceholder: '搜索关键词',
		pluginsTip: '雅意大模型会基于你的问题判断需要调用库中的哪个插件回答。',
		presetOne: '示例一',
		presetTwo: '示例二',
		presetThree: '示例三',
		enterName: '请先输入智能体名称',
		enterIntroduction: '请先输入智能体名称和智能体简介',
		completeSample: '请输入完整预置内容后再添加',
		promptList: '指令中心',
		agentAll: '公开',
		agentHot: '热门',
		agentMy: '我的',
		agentName: '智能体',
		infoMessage: '存在上传中或解析中的文件请稍后再试！',
		linkInfo: '链接重复',
		fileInfo: '文件重复',
		infoWords: '简介限制500个字',
		pluginsInfo: '请选择插件',
		lineCheck: '联网查询：',
		ready: '问题深度剖析中',
		running: '问题剖析完毕，检索中',
		finish: '正在读取网页总结中',
		arrow1: '展开',
		arrow2: '收起',
		null: '不能为空',
		refreshInfo: '刷新调试',
		select: '{name}已添加',
		noselect: '{name}已删除',
		chat: 'Chat',
		serach: 'AI搜索',
		kyzs:'Agent',
		file: '知识库',
		uie: '知识抽取',
		placeholder: '请输入示例值',
		write: 'AI写作',
		flash: '长文',
		publicInfo: '发布磐石智能体',
		publicInfo1: '无需登录，打开即用——开放式智能体快捷方式',
		ignore: '下次不再提示',
		create: '创建发布链接',
		info: '已复制发布链接，可前往',
		info1: '个人中心>发布管理',
		info2: '中管理发布记录',
	},
	notice: {
		activityTitle: '参与活动',
		activityContent: '参与新手福利或邀请好友，免费赢取额外研值',
		activityButton: '去参与',
		upgradeTitle: '升级套餐',
		upgradeContent: '按月/按年订阅，获得更多研值及权益',
		upgradeButton: '去升级',
	},
	recharge: {
		fees: '账户余额欠费',
		noiceTitle: '账户余额提示',
		noiceTip: '为不影响您的正常使用，建议您先充值帐户。',
		later: '稍后再说',
		goRecharge: '去充值',
		insufficientBalance: '余额不足',
		message1: '该次服务调用扣费',
		message2: '您账户当前剩余',
	},
	addRole: {
		limitUpload: '最多添加三个预置问题',
		select: '头像选择',
		model: '模型',
		file: '知识文件',
		upload: '上传文件',
		info: '支持文件类型：.doc .docx .pdf .txt Markdown...最多十个',
		about: '约',
		text: '字',
		desc: '一句话描述你的智能体',
		desc1: '极速模式',
		placehold: '请输入描述语',
		desText: '描述',
		add: '生成智能体配置',
		addUrl: '添加URL',
		limit: '限制10个',
		address: 'URL地址',
		cancel: '取消',
		confrim: '确定',
		exapmle:
			'作为一个舆情分析师，可以通过用户提供的热点资讯，分析该热点资讯产生的市场效应，并总结概述、分析事情产生的原因、事件产生的结果，若有参与人也请一并列出。',
		info1: '请输入URl',
		info2: '最多上传10个文件',
		info3: '最多上传10个Url',
		status1: '上传中...',
		status2: '解析中...',
		status3: '失败',
		intell: '智能体',
		all: '全部',
		hot: '热门',
		my: '我的',
		technologySet: '问例配置',
		kowledge: '知识库配置',
		base: '基础配置',
		setting: '插件配置',
		addExample: '添加示例',
		uploadUrl: '添加URL',
		uploadKnowledge: '关联知识库',
		selected: '已选择',
		selectedName: '个文件',
		placeHolder: '关键词搜索',
		answerModel: '回答模式',
		v2: '智能模式',
		v3: '高级搜索',
		v2Info: '基于问题判断需要调用的插件回答',
		v3Info: '将问题拆解为相互关联的子问题，再进行联网检索',
		vInfo: '不选择任何插件时仅能通过雅意大模型直接回答问题',
		selctPlugin: '插件',
		creatSet: '创造力',
		infoSubmit: '请先完善基础配置',
		pluginInfo1: '接入互联网检索信息',
		pluginInfo2: '借助计算器进行数学运算',
		pluginInfo3: '支持未来7天（含当日）天气查询',
		pluginInfo4: '根据网络热度获取指定主题最新热点信息',
		pluginInfo5: '借助生成和执行代码获取数学运算、图表绘制、Md表格问答等精确结果',
		pluginInfo6: '分步骤生成大纲和万字长文',
		gotoFile: '前往知识库',
		modelTitle: '高级搜索不支持挂载知识库',
		modelInfo: '继续切换模式已选知识库将失效',
		modelInfo1: '您也可以在"智能模式下勾选"联网"插件，以实现智能体的联网功能',
		continue: '继续',
		edit: '编辑',
		remove: '移除',
		auxiliary: '辅助功能',
		open: '启用',
		close: '禁用',
		baseInfo: '基础信息',
		appendFun: '扩展功能',
		redAnaly: '文件阅读分析',
		readTitle: '文件阅读分析操作指南',
		readInfo: '解读用户发送的文件内容回答问题',
		fileType: '支持文件格式',
		webAnaly: '网页阅读分析',
		webTitle: '网页阅读分析操作指南',
		webInfo: '解析用户发送的网页链接内容回答问题',
		preQuestion: '预置问题',
		addQuestion: '添加问题',
		questionTitle: '问题名称',
		questionTitleInfo: '不填写时按钮将直接展示问题内容',
		questionCintentInfo: "可通过输入“{'{}'}”在问题中添加变量，如：“{'{'}内容{'}'}”",
		placeHold1: '进入智能体显示的预置问题按钮名称',
		placeHold2: '想要发送的信息内容',
		content: '问题内容',
		name: '文件名',
		state: '上传状态',
		size: '上传大小',
		operation: '操作',
		valid: '变量',
		confirm: '确定',
		infoValid: '变量默认值不能为空',
		infoError: '请先删除异常文件',
		infoLimit: '字数超出限制，请删减内容',
		crate: '创建预置问题',
		editQ: '编辑预置问题',
		nodata: '暂无分享智能体',
		share: '分享给我',
		infoUpload: '上传文件后智能体将支持输入问题时上传对应格式的文件',
		infoSwitch: '预置问题中包含已上传文件，不可禁用',
		selectDisInfo: '预置问题中已上传该格式文件，不可取消勾选',
		deleteInfo: '删除后所有用户将无法继续与该智能体对话，已经产生的对话记录不受影响。',
		uploadSuccess: '上传成功',
		type: '知识库类型',
		modelTitle1: '确认切换知识库类型吗？',
		modelInfo2: '继续切换知识库类型已选知识库将失效',
		uploadText: '拖动到此，上传文件',
		loading: '正在生成配置... （{time}s）',
	},
	search: {
		yayi: '雅意',
		search: '搜索',
		change: '换一批',
		hot: '今日热点',
		recommend: '推荐',
		origin: '来源',
		sendTitle: '请输入问题再发送',
		webOrigin: '网络信源类型',
		web: '网络',
		file: '知识库',
		info: '请输入内容',
		select: '至少选择一个类型',
		selectInfo: '请至少选择一个网络来源',
		webInfo: '请选择网络来源',
		webAll: '全网',
		originSelect: '指定来源',
		webAllInfo: '搜索全网资料获取答案',
		originInfo: '请至少选择一个来源',
		guess: '猜你想搜',
	},
	longText: {
		loadMessage: '请稍候片刻，精彩即将呈现...',
		loading: 'AI生成',
		success: '生成成功，可前往',
		link: '记录>作品',
		check: '查看',
		fail: '作品生成失败',
		fail1: '好像遇到一些问题，请等一会儿再试吧~',
	},
	share: {
		longWrite: '长文',
		totalWords: '总字数：{total}',
	},
	aside: {
		submitSuccess: '提交成功',
		submitFail: '提交失败',
		expandMenu:'展开',
		collapseMenu:'收起',
		going: '进行中',
		nodata: '暂无进行中的任务',
		aboutsUs: '关于我们',
		system: '跟随系统',
		system1: '跟随系统',
		light: '量子白',
		dark: '暗物质',
		wait: '请稍候',
		time: '预计剩余{time}小时',
		useGuide:'使用说明',
		questionnaire: '问卷调查',
		feedback: '意见反馈',
		awaiting: '等待确认',
		theme:'系统主题',
		billing:'研值余额',
		rightsRedeem:'权益兑换',
		personal:'用户中心',
		moreInfo:'更多信息',
		rulesAgreements: '规则协议',
		upgrade:'升级',
		joinEventsGetCoins: '参与活动获取研值！',
		expires: '到期',
        lifetimeMembership: '永久有效',
		renew: '续期',
		task: "新手任务",
		taskDesc: "完成限时研值活动，累计获得",
		taskDesc2: "研值奖励!",
		survey: '问卷调查',
		surveyDesc: '为更好地服务您的科研工作，诚邀您参与本次调研',
		checkTips: '请至少选择一项',
		fillTip: '请填写内容',
		team: '磐石产品团队',
		next: '下一步',
		previous: '上一步',
		submit: "提交",
		placeholder: '请在此输入您的建议或意见（限500字）',
		newTaskTip: '有新手任务上新啦，完成可得研值',
		checkTip: '今日签到完成后可得',
		checkTiCioins: '研值'
	},
	assiant: {
		title: '开启Agent之旅...',
		caseTitle: '探索使用案例',
		recommend: '推荐',
		deepModel: '深度研究',
		deatilSurvey: '长文',
		placeHolder: '打算深入探究的内容、希望了解的问题，都可以发给我~',
		fillAtLeastOne: '请至少填写一项内容后再提交',
		survey: '学术信源',
		surveyInfo: '学术期刊、会议论文集',
		file: '文献库',
		fileInfo: '检索文献库中的数据',
		fileInfo1: '请至少设置选择一个文献库',
		tools: '学术工具',
		toolsInfo: '包含多种科研工具',
		toolsInfo1: '请至少设置选择一个学术工具',
		webSource: '网络资料',
		webSourceInfo: '全网最新资讯',
		more: '更多',
		processing: '正在进行中',
		confrimMessage: '将在你确认后继续工作',
		report: '可视化报告',
		document: '文档',
		writeSurvey: '写综述',
		web: '做网页',
		ppt: 'PPT',
		poster: '海报',
		selectQuestion:'选题研判',
		plan: '任务规划',
		goResult: '跳转到结果',
		taskRunningTip: '研究任务已开始，将在后台持续进行。您可以随时关闭页面，通过历史记录查看结果。',
		preview: '预览',
		code: '源码',
		reset: '重置',
		submit: '提交',
		inputInfo: '输入回车创建多个关键词',
		addTitle: '添加下级标题',
		Chapter: '第{number}章',
		addChapter: '添加章节',
		taskInfo: '当前排队人数较多，请耐心等待...',
		cancelTaskInfo: '取消排队',
		cancelTaskInfo1: '排队取消',
		cancelTaskInfo2: '已取消排队',
		taskFail: '排队失败',
		analyzing: '解析文献：',
		totalSum: '第{num}个/共{totalNum}个',
		support: '中科院自动化所&中科闻歌联合技术支持',
		all: '全选',
		noData: '暂无数据',
		selectTool: '学术工具选择',
		dataInfo: '国内外权威论文数据库集',
		sourceInfo: '已规划 {number} 个步骤，检索 {totalNum} 条信息',
		sourceInfoPPT: '已规划 {number} 个步骤',
		time: '已运行{number}min',
		workspace: '工作区',
		task: '任务',
		origin: '来源',
		files: '生成文件',
		createInfo: '请先创建或选中一个任务',
		completed: '已完成',
		checkView: '查看过程文件',
		failInfo: '很抱歉，执行过程中出现异常，智能体已停止运行，请检查输入信息或重试。',
		failInfo1: '系统繁忙，请稍后再试。',
		terminate: '用户停止',
		library: '文献',
		webResource: '网络资料',
		otherData: '其他数据',
		brief: '简要信息',
		cited: '已引用',
		uncited: '未引用',
		slectInfo: '按搜索关键词筛选',
		clean: '清空筛选',
		processFile: '任务过程文件',
		result: '搜索结果',
		collapse: '收起过程文件',
		thinking: '思考过程',
		All: '全部',
		running: '正在进行中',
		run: '进行中',
		leastTime: '预计剩余',
		finishing: '即将完成...',
		minutes: '分钟',
		hour: '小时',
		review: '长文',
		unclassified: '未分类文件',
		allView: '显示所有附件',
		message: '信息',
		downLoad: '下载',
		full: '全屏',
		fold: '收起',
		copyConetnt: '复制内容',
		using: '正在使用',
		browser: '浏览器',
		search: '搜索',
		terminal: '终端',
		editor: '编辑器',
		mediaViewer: '媒体查看器',
		chart: '图表',
		unactived: '未激活',
		tree: '分类树',
		add: '添加',
		noAuth: '未授权',
		setPlugin: '配置扩展',
		authInfo: '请完成账号授权，点击授权',
		finish: '任务回放已结束',
		taskLoading: '回放任务中..',
		revivew: '重看',
		searchLists: '搜索列表',
		outline: '大纲',
		resultFile: '最终结果文件',
		noContent: '暂无内容',
		noSearch: '已添加新的关键词，待搜索',
		noPreview: '暂不支持预览',
		downLoadInfo: '请下载文件以查看其内容',
		excel: '列表',
		titleCapt: '标题',
		placeHolderTitle: '请输入标题',
		placeHolderRemark: '请输入你的备注',
		addCurrentCapt: '添加同级章节',
		addSubCapt: '添加子章节',
		addNode: '添加同级节点',
		addChat: '新建对话',
		newDesign: '新建设计',
		newSolve: '新建求解',
		addSession: '新建会话',
		shareInfo: '复制对话链接',
		shareSucessInfo: '分享链接已复制，快去分享吧',
		linkeInfo: '请选择理由帮助我们做的更好（可选）',
		disLikeInfo: '请选择理由帮助我们做的更好（可选）',
		other: '其他...',
		record: '感谢您的反馈！',
		stopChat: '用户已停止本次对话',
		detailInfo: '添加具体细节',
		think:'思考中',
		taskProcess:'任务进度',
		submitted:'超时未确认，系统已自动提交。',
		shareInfo1:'{name}：[{title}]分享给您,点击查看：\n{link}\n ——来自「磐石·文献罗盘」',
		deepResearch:'深度研究',
		deepSurvey:'长文',
		deepSurvey1:'综述模式',
        analysisModel:'选题研判',
		reviewModel:'论文审稿',
		turboModel:'极速模式',
		illustration:'配图',
		noHistory:'暂无该模式下的历史记录',
		selectLanguage:'请确认综述的写作语言',
		chinese:'中文',
		english:'英文',
		allHistory: '全部记录',
		surveyReport:"学术综述报告",
		researchReport:"深度研究报告",
		aiChatReport:"AI对话纪要",
		shareInfo2:'我在「磐石·文献罗盘」用{name}聊到一些内容，分享给您看看～\n👉 {link}',
		shareInfo3:'我用「磐石·文献罗盘」生成了一个{name}，分享给您看看～\n👉 {link}',
		shareInfo4:'我用「磐石·文献罗盘」生成了{name}，分享给您看看～\n👉 {link}',
		shareturboModel:'极速模式',
		sharedeepResearch:'深度研究',
		sharedeepSurvey:'长文',
		shareImg:'配图',
		sharePPT:'PPT',
		sharePoster:'海报',
		uploadPPT: '上传文献，一键生成PPT',
		uploadPoster: '上传文献，一键生成海报',
		uploadPaper: '上传论文，一键生成审稿建议',
		placeHolderIllustration: '描述您想绘制的图片',
		placeHolderSurvey: '输入您的研究问题，获取专业综述',
		placeHolderCharge: '输入选题思路或上传相关材料，进行创新性、必要性、经费合理性等研判分析',
		targetLanguage: '语言',
		generatePPTFromLiterature: '基于以下文献生成PPT，输出语言为[{lang}]',
		generatePosterFromLiterature: '基于以下文献生成海报，输出语言为[{lang}]',
		generatePaper: '基于以下文献生成论文审稿，输出语言为[{lang}]',
		writeInfo:'感谢您对生态联盟的贡献。去填写您的用户单位',
		selectunit:"完善用户单位",
		unitInfo:'完善资料可以帮助我们为您提供更精准的服务，您的信息安全保密,请放心填写。',
		unit:'所属单位',
		unitPlaceHold:'请输入单位名称',
		confirm:'确定',
		tip:'温馨提示',
		unitinfo:'·单位信息将用于身份验证和服务匹配',
		unitinfo1:'·如果您的单位不在列表中，请直接输入完整单位名称',
		unitinfo2:'·所有信息均会严格保密，仅用于提供更好的服务',
		regenerate: '重新生成',
		edit:'编辑',
		cancelEdit:'取消编辑',
		leastChart:'最少输入2个字符',
		mostChart:'最多输入100个字符',
		keywordInfo:'最少保留1组关键词',
		keywordInfo1:'最多输入10组关键词',
		editInfo:'请在工作区编辑文档内容',
		version:'版本',
		versionInfo:'原始/修订V1.0/修订V2.0/修订V3.0',
		editTimeInfo:'文件内容最多支持编辑3次',
		chartInfo:"最少保留50个字符",
		chartInfo1:"最多输入3万个字符",
		titleInfo:'提示',
		deleteInfo:"是否删除 {number} 条搜索结果，并立即开始重试",
		deleteOnly:'仅删除',
		retryNow:'立即重新生成',
		saveInfo:'是否保存修改并立即重新生成',
		cancel:'取消',
		rightRegenerate:'立即重新生成',
		regenerateFail:'重新生成失败，请稍后再试',
		contentInfo:'内容不能为空',
		view:'全屏查看',
		theme:'颜色',
		size:'尺寸',
		analysisModelInfo:'全维度剖析生成研判报告',
		reviewModelInfo:'导入文献生成审稿建议',
		deepSurveyInfo1:'梳理千篇文献生成万字长文',
		deepSurveyInfo2:'阅读理解万篇学术资源，动构建知识体系',
		deepSurveyInfo3:'自定义大纲结构，文献可溯源，一键导出完整综述',
		pptInfo1:'导入文献转换PPT ',
		pptInfo2:'智能提取论文图表与核心观点，素材真实可溯源',
		pptInfo3:'支持在线预览与二次编辑，灵活适配多种场景',
		illustrationInfo1:'自然语言生成科研配图',
		illustrationInfo2:'精准理解专业术语，覆盖理论模型、实验设计、数据分析全流程',
		illustrationInfo3:'多轮对话调整细节，快速导出高清科研插图',
		posterInfo1:'导入文献排版海报',
		agentLoopInfo1:"测试智能体",
		posterInfo2:'多尺寸模板自动布局，排版专业视觉规范',
		posterInfo3:'支持在线预览与二次编辑!适配各类学术会议场景',
		setUnitSuccess:'绑定成功',
		uploadInfo:'支持上传1份格式为.pdf/.doc/.docx的文献，文件大小在20M以内',
		uploadInfo1:'支持上传1份格式为.pdf/.doc/.docx/.txt/.md的文献，文件大小在20M以内',
		answerFail:'系统繁忙，请稍后重试',
		answerTerminated:'用户已停止本次对话',
		settingInfo:'信源及配置',
		settingInfo1:'配置',
		addKeyWords:'添加搜索关键词',
		moreTotal:'(最多10条)',
		keyWordesInfo:"修改搜索关键词后",
		keyWordesInfo1:'将进行重新搜索',
		resetInfo:'还原',
		deletekeywordsInfo:'已删除搜索关键词，并同步删除对应搜索列表',
		sciTools:'科学工具',
		taskName:"任务名称",
		enterTaskName:'请输入任务名称',
		taskNameInfo:'1-48个字符，由小写英文、数字、符号(-、_)组成，以英文开头，以英文或数字结尾',
		softType:'软件格式',
		uploadFile:"上传文件",
		fileLoading:'上传中',
		useManual:"使用手册",
		ctlInfo:"请上传ctl文件：",	
		groInfo:"请上传gro文件：",	
		topInfo:"请上传top文件：",	
		rst7Info:"请上传rst7文件：",	
		parm7Info:"请上传parm7文件：",	
		dataFileInfo:"请上传data文件：",	
		inInfo:"请上传in文件：",	
		deleteErrInfo:"删除失败",
		topReserchLang:"分析该项目材料，基于相关政策、前沿技术，围绕重大需求和战略，从技术先进性、经费合理性、相关建设项目等方面，对该项目开展综合研判。",
		fileErrInfo:"您的文件格式不符合要求，请处理后再上传",
		newComput:"新建计算",
		skills: '技能',
		webSources: '网络信源',
		literature: '专业学术文献',
		networkTools: '通用搜索资料',
		input: '请输入',



	},
	survey: {
		title: '撰写学术综述',
		copy: '复制',
		chat: '对话',
		anno: '批注',
		guide: '导读',
		session: '记录',
		selectContent: '已选中内容',
		placeHolder: '请输入问题',
		hi: '您好',
		welcome: '欢迎提问，我可以帮您解读综述内容',
		terminated: '用户已停止本次对话',
		reference: '参考来源',
		save: '保存',
		content: '主题内容',
		keyWord: '关键词',
		objectives: '研究目的',
		views: '核心观点',
		support: '论据支持',
		deleteInfo: '确认删除此会话',
		cancel: '取消',
		confirm: '确认',
		refNet: '引文回溯',
		legend: '图例',
		count: '引用次数',
		positive: '正向引用',
		negative: '负向引用',
		graph: '网络图',
		timeLine: '时间线',
		referenceInfo: '参考文献',
		current: '当前文献',
		citing: '引证文献',
		noneInfo: '您还没有写过学术综述',
		none: '暂无',
		write: '相关综述，写一篇吧~',
		literatureDetails: '文献详情',
		view: '查看原文',
		add: '加入文献库',
		type: '成果物类型',
		keywords: '请输入关键词搜索',
		name: '标题',
		saveToLibrary: '另存到文献库',
		enterLibraryName: '请输入文献库名称',
		update: '更新',
		hello: '您好',
		welcomeHelp: '欢迎提问，我可以帮您',
		interpretSummary: '解读综述内容',
		noteSuccess: '批注成功',
		noteErr: '批注失败',
		pleaseEnter: '请输入',
		new: '新',
		addSuccess: '添加成功',
		articleExists: '当前文献已在知识库中',
		selectFolder: '请选择文件夹',
		delTip: '确定要删除',
		pending: '挂起中',
		running: '进行中',
		success: '成功',
		fail: '执行失败',
		abort: '手动终止',
		terminatedChat: '手动终止',
		noMessage: '暂无相关信息',
	},
	result: {
		favorite: '收藏',
		type: '类型',
		search: '查找成果物',
		model: '仿真模型',
		report: '可视化报告',
		other: '其他',
		origin: '已参考{number}个权威来源',
		reName: '重命名',
		view: '查看研究',
		delete: '删除',
		interpretation: '智能解读',
		reNameResult: '重命名成果物',
		deleteInfo: '确认删除您的成果物吗',
		deleteSuccess: '成果物已被用户删除',
		processing:'进行中',
		fail:'任务失败',
		stop:'任务已停止',
		confirm:'待确认'	

	},
	writeNotice:{
		info:'🌟 您的声音，至关重要！',
		btnInfo:'📩 告诉我们您的体验',
		title:'致ScienceOne用户的一封信',
		user:'尊敬的磐石用户：',
		hi:'您好！',
		text1:'衷心感谢您对“磐石”的关注与支持！自产品发布以来，获得了远超预期的关注与使用。随着使用量的持续增长，系统算力资源面临较大压力，尤其是在生成“学术综述”功能时，部分用户出现超过 6 小时的等待或任务超时问题。对此，我们深表歉意。',
		text2:'“磐石”团队正全力推进系统升级与算力扩容，力求尽快提升产品性能，为全球科研人员提供更加高效、流畅的使用体验，再次感谢您的理解与耐心等待。诚邀您点击下方按钮填写问卷，您的宝贵反馈将帮助我们不断优化产品，持续进步。',
		text3:'诚邀您点击下方按钮填写问卷，您的宝贵反馈将帮助我们不断优化产品，持续进步。',
		btnInfo1:'点击此处，填写问卷',
		groupName:'磐石产品团队'

	},
	notification:{
		all:'全部',
		unread:'未读',
		allReaded:'全部已读',
		noReadData:'暂无未读消息',
		read:'已读',
		view:'查看',
		info:'您有{n}条未读消息，点击查看',
		messageCenter:'消息中心',
	},
	changelog:{
		title:'更新日志',
	},
	feedback:{
		title:'意见反馈',
		info1:'我们非常重视您的反馈意见，并致力于不断改进我们的服务。如果您有任何建议，可通过邮箱反馈给我们',
		// title1:'问卷反馈',
		// info2:'我们会定期汇总分析问卷数据，从中发现产品改进机会。您的每份反馈都在推动产品变得更好。',
		// info3:'问卷填写地址：',
		title2:'邮箱反馈',
		info4:'我们会在收到邮件后7个工作日内回复，为您的具体问题提供针对性解答，让每一个问题都有回音。',
		info5:'联系我们的邮箱：',
		info6:'感谢您使用ScienceOne，让我们一起打造更优质的学术研究体验！'

	},
	basis: {
		subjectClassification: '学科分类',
		all: '全部',
		foundTotalDatabases: '共找到 {total} 个数据库',
		searchDatabase: '搜索数据库',
		accessMethod: '访问方式',
		onlineQuery: '源代码',
		apiInterface: 'API接口',
		dataDownload: '数据下载',
		license: '许可协议',
		databaseName: '数据库名称',
		title: '科学数据库',
		slogan: '汇聚全球权威科学数据库 为科研工作者提供一站式数据检索与获取服务',
		inputSearchContent: '输入搜索内容',
		scientificData: "科学数据",
		backToDatabaseList: "返回数据库列表",
		goToOfficialWebsite: "去官网",
		share: "分享",
		databaseOverview: "数据库概览",
		publishingInstitution: "发布机构",
		mainApplicationScenarios: "主要应用场景",
		copyrightNotice: "版权须知",
		unknownResource: "未知资源",
    shareMessage: "我在「磐石·文献罗盘」里找到了一个超棒的【 {name} 】资源，分享给您看看～ [{url}]",
    copySuccess: "链接已复制"
	},
	news: {
		all: '全部',
		papers: '论文',
		news: '新闻',
		openAccess: '公开访问',
		pdf: '查看PDF',
		citationCount: '被引',
		abstract: '摘要',
		filter: '筛选',
		default: '默认',
		today: '今天',
        last3Days: '近3天',
		last7Days: '近7天',
		last30Days: '近30天',
		last6Months: '近半年',
		lastYear: '近一年',
		addtoLibrary: '收藏到文献库',
		minutesAgo: '分钟前',
		hoursAgo: '小时前',
		daysAgo: '天前',
		addedToLibrary: '已收藏到文献库',
		viewSource: '访问原文',
		academicPPT: '生成PPT',
		academicPoster: '生成海报',
		noMoreData: '没有更多数据了',
	},
	tool: {
		shareMessage: "磐石·科学工具：{name} —— {url} ",
		sciTools: "科学工具",
		featured: "推荐",
		all: "全部",
		saved: "我的",
		searchPlaceholder: "输入关键词，搜索全部工具",
		searchTools: '输入关键词，搜索我的工具',
		heaCatalystTitle: "碱性条件下析氢反应的高活性高熵合金 (HEA) 催化剂设计",
		useNow: '立即使用',
		runImmediate: "立即使用",
		details: '查看详情',
		popular: "热门",
		scene: '场景',
		disciplines: '学科',
		toolCount: "共找到 {total} 个工具",
		overview: "概述",
		capabilities: "核心能力",
		limitations: "使用限制",
		useCases: "应用实例",
		input: "输入：",
		output: "输出",
		form: "表单",
		running: "运行中",
		complete: "运行成功",
		failed: "运行失败",
		copy: "复制",
		download: "下载",
		run: "运行",
		addToolSuccess: "添加工具成功",
		addToolFailed: "添加工具失败",
		remove: '移出我的工具',
		removeToolSuccess: '移除工具成功',
		removeToolFailed: '移除工具失败',
		feature: '精选',
		viewAll: '查看全部',
		add: '添加到我的工具',
		added: '已添加',
		share: '复制分享链接',
		useTools:'工具使用',
		json:"JSON",
		outPut:'输出',
		noInputData: '暂无数据',
		noData:'暂无输出结果',
		placeHold1:'请输入催化剂设计需要包含元素数量和推荐合金数量',
		placeHold2:'请输入待求解的偏微分方程及其约束条件',
		preview:"公式预览",
		closePreview:'退出预览',
		outPut1:"输出：",
		notRun:'未运行',
		heaExample:'根据文献资料，设计适用于{name}',
		equationVariablePlaceholder: '请输入 {name} 的值',
		equationRequired: '{name} 不能为空',
		equationInvalidNumber: '{name} 必须是有效的数字',
		equationSubmitInvalid: '请填写所有必填项，并确保输入的是有效数字',
	},
	about:{
		title:'Literature是基于磐石科学基础大模型整合大量科技文献并为科研人员完成多步深度调研、研究方向图谱梳理、文献综述写作等多种科研任务的智能体系统。',
		title1:'功能定位',
		name:'公司/机构',
		name1:'上海算法创新研究院',
		name2:'中国科学院',
		name3:'产品',
		name4:'思考模型',
		name5:'发布时间',
		name6:'更懂科学语言',
		name7:'研究方向图谱生成',
		name8:'论文图谱生成',
		name9:'高质量科技综述生成',
		name10:'文献库与受限环境下的论文精读',
		name11:'幻觉减少程度',
		low:'低',
		medium:'中',
		high:'高',
		title2:'核心技术',	
		desc1:'科学语料构建（Science Corpus）',
		desc3:'依托文献情报中心<span class="important">超过2亿份</span>科技文献数据（包括：<span class="important">1.6亿余份</span>论文摘要、<span class="important">7,000余万份</span>论文全文），构建<span class="important">全量科技文献预训练数据</span>，用于科学大模型继续预训练。',
		desc4:'继续预训练（Continue Pre Train）',
		desc5:'面向科学领域，基于<span class="important">DeepSeek-V3/R1-671B</span>模型在大规模科学教材与科技文献语料上进行继续预训练。提升模型<span class="important">理解科学语言</span>的能力，支持理解<span class="important">谱数据</span>、<span class="important">场数据</span>、<span class="important">核酸</span>等多种科学模态数据。',
		desc6:'后训练（Post Train）',
		desc7:'采用符合科学逻辑的后训练深度分析框架，基于课程学习的SFT精细化训练，分阶段提高模型全科科学推理能力。采取基于群组相对策略优化GRPO的高效RL（Reinforcement Learning）训练，强化模型<span class="important">遵循科学逻辑推理</span>的能力。',
		desc8:'后推理（Inference）',
		desc9:'采用启发式广度优先搜索，提升论文研究调研覆盖度，结合迭代式深度优先搜索，深度挖掘研究方向论文深度，<span class="important">更专业地理解、规划、执行科学任务</span>。针对不同类型的科学任务自动在不少于5个学术信源（<span class="important">科技文情</span>、<span class="important">谷歌学术</span>、<span class="important">arXiv</span>、<span class="important">PubMed</span>、<span class="important">ScienceDirect</span>）自动规划探查路径，通过模型自动计算用户提出的问题与文献数据的相关程度。',
		title3:'关键优势',
		info:'全方位科研助力',
		info1:'<span class="important">多学科深度理解能力：</span>融汇数理化生材等多个学科领域，精准解读论文中的公式、图表、实验数据等科学模态内容，深度剖析文献核心要点，实现术语、定理、模型的深度理解与对齐。',
		info2:'<span class="important">专业综述写作：</span>自动预览上千篇文献，通过边阅读边归纳、边写作边加工的方式，可生成4万字以上的综述篇幅。综述结果在结构质量、内容覆盖度、主题相关性、批判性四个维度综合评估指标优秀，引文真实可靠。',
		info3:'<span class="important">文献创新网络：</span>在公认学术评价指标之上，建立“创新延续”链路、“知识演进”图谱，指导新知识的创造和推理，进而从另一个视角开展更加“客观和直接”的学术评价。',
		info4:'专业数据与模型基石',
		info5:'<span class="important">海量优质语料：</span>整合中国科学院文献情报中心（约1.7亿） + 谷歌学术（约3.8亿）+arXiv（240万预印本）科技文献权威信源，并保持实时更新，最大限度减少幻觉和偏见，为研究提供坚实数据基础。',
		name12:'信源',
		name13:'数据量',
		name14:'数据时效性',
		name15:'说明',
		value1:'文献情报中心',
		value2:'约1.7亿',
		value3:'不定期动态更新',
		value4:'在线API',
		value5:'谷歌学术',
		value6:'约3.8亿',
		value7:'实时更新',
		value8:'在线API',
		value9:'arXiv',
		value10:'约240万',
		value11:'实时更新，年均增长约18万篇',
		value12:'覆盖物理、计算机科学、数学等领域',
		value13:'Springer',
		value14:'超1,400万',
		value15:'实时更新，覆盖2,200余种期刊',
		value16:'涵盖科学、技术和医学（STM）及人文社科领域',
		value17:'Elsevier',
		value18:'约9,100万',
		value19:'实时更新，年均增长约50万篇',
		value20:'涵盖医学、工程和计算机科学等领域的240个学科',
		value21:'PubMed',
		value22:'约3,200万',
		value23:'实时更新，每日新增约3,000篇',
		value24:'覆盖临床医学、遗传学等方向',
		value25:'<span class="important">领域定制大模型：</span>科学基础大模型在 GAIA 等学术任务上表现卓越，精准适配科研需求。',
		title4:'主要功能',
		func1:'科研助手',
		func2:'整合文情中心、arXiv 等多源权威数据，为科研提供一站式知识服务。输入科学问题，基于磐石科学基础大模型深度理解专业内容，自动拆解任务，过滤低质信息，生成研究结果。科研助手仅用学术认证内容源，确保结论可靠，具备跨学科解答、设计实验方案等能力，支持生成多模态交互结果，全方位助力科研。',
		title5:'文献库',
		func4:'汇总文献并辅助精读，利用磐石科学基础大模型精准理解论文的文、公式、表、图像内容，助力科研人员快速精读文献，一键生成研究导读。精读时可助研究人员构建引文网络，定位权威学者，将碎片化文献转为可交互知识网络，让科研人员随时整理阅读。',
		title6:'学术综述',
		func5:'数小时内自动搜集、计算、阅读数千篇文献，梳理综述骨架，生成全面专业综述。采用人机交互写作模式，允许研究人员干预写作，优化生成高质量综述，相较传统方式，提升撰写效率与质量。',
		

		
	},
	// 新手引导
	newUserTutorial:{
		step1Card1Title:'科学深度研究',
		step1Card1Desc:'深度研究 Deep Research 针对各类科研难题，提供更全面、更具权威性的解答。',
		step1Card2Title:'全能附件解析',
		step1Card2Desc:'支持多格式资料投喂，实现跨文档关联分析与观点提炼。让复杂文献的处理变得轻而易举。',	
		step1Card3Title:'信源与输出设置',
		step1Card3Desc:'自定义文献范围与输出格式，给你严谨专业且符合预期的产出，精准合规，即刻可用。',
		step2Card1Title:'选题研判',
		step2Card1Desc:'用2.2亿科学数据，帮你在选题上看全背景、看透原理、找准时机，锚定创新高地，成果快人一步。',
		step2Card2Title:'学术综述',
		step2Card2Desc:'无需复杂提示词，一次性梳理万篇文献，脉络清晰，交付你博士级别的综述成果。',
		step2Card3Title:'学术审稿',
		step2Card3Desc:'拥有顶刊视野的AI审稿人，多维度把关，给你全面、专业、结构化的修改建议，提升你的论文录用率。',
		step2Card4Title:'多维成果转化',
		step2Card4Desc:'一键上传论文，智能生成专业规范的配图、ppt和海报，科研可视化，从未如此简单。',
		step3Card1Title:'科研助手',
		step3Card1Desc:'专属AI科研伙伴，深度参与文献研读与论文撰写，精准理解研究意图，高效助力科研产出。',
		step3Card2Title:'文献库',
		step3Card2Desc:'你身边的文献阅读帮手，按科研逻辑精读文献，从单篇精读到全库对话，深挖每一篇文献的价值。',
		step3Card3Title:'数据与工具',
		step3Card3Desc:'汇集权威数据库与专业分析工具，提供从设计到验证的一站式方案，让科研探索更有据可依。',
		step3Card4Title:'科研资讯',
		step3Card4Desc:'实时追踪全球学术前沿，精准推送高价值动态。助您捕捉学科趋势，始终走在研究最前线。',
		skipTutorial:'跳过引导',
		getStarted:'进入磐石',
		next: '下一步',
		previous: '上一步',
		startTask: '开始任务',
		surveyTaskStep1Title: "选择您需要的智能体",
		surveyTaskStep1Desc: "点击底部功能栏的按钮，选择您需要的智能体。支持长文、PPT、配图、海报等多种创作模式。",
		surveyTaskStep2Title: "配置信源与输出语言",
		surveyTaskStep2Desc: "在左侧面板中打开或关闭文献库、网络信源，并可切换产物输出语言（中文/EN），灵活控制内容来源。",
		surveyTaskStep3Title: "输入并发送研究需求",
		surveyTaskStep3Desc: "在对话框中用自然语言描述或上传学术文献以输入研究需求，确认无误后，点击右下角发送按钮，Agent将立即开始处理您的请求。",
		surveyTaskStep4Title: "查看历史记录",
		surveyTaskStep4Desc: "点击左侧导航中的【历史记录】，可以查看您所有的历史研究记录。",
		surveyTaskStep5Title: "使用预置指令快速启动",
		surveyTaskStep5Desc: "对话框下方展示了示例预置指令，点击任意一条即可将其填入对话框，快速复用研究任务，无需重新输入，立即开始体验吧！",
		agentTaskStep1Title: "选择深度研究模式",
		agentTaskStep1Desc: "点击对话框左下角的[深度研究]按钮，进入深度研究模式，解决复杂场景科研需求。",
		agentTaskStep2Title: "配置技能、信源与输出语言",
		agentTaskStep2Desc: "在左侧面板中选择技能，打开或关闭文献库、网络信源，并可切换产物输出语言（中文/EN），灵活控制内容来源。",
		// agentTaskStep3Title: "配置信源与输出语言",
		// agentTaskStep3Desc: "在右侧面板中打开或关闭学术资源、文献库、网络资料，并可切换产物的输出语言（中文",
		// agentTaskStep4Title: "发送研究需求",
		// agentTaskStep4Desc: "确认内容无误后，点击右下角发送按钮，AI将立即开始处理您的请求并生成学术内容",
		// agentTaskStep5Title: "查看历史记录",
		// agentTaskStep5Desc: "点击左侧导航顶端的「历史记录」，可以查看您所有的历史研究记录，随时回溯并继续之前的研究方向",
		// agentTaskStep6Title: "使用预置指令快速启动",
		// agentTaskStep6Desc: "对话框下方展示了近期使用的预置指令，点击任意一条即可将其填入对话框，快速回复已有研究任务，无需重新输入，立即开始体验吧",
		// academicTaskStep1Title: "选择学术综述智能体",
		// academicTaskStep1Desc: "点击底部功能栏的「学术综述」按钮，选择您需要的智能体类型。除综述之外，还支持学术PPT、学术配图、学术海报等多种创作模式。",
		academicTaskStep2Title: "配置产物语言和颜色",
		academicTaskStep2Desc: "在左侧面板中切换输出语言（中文/EN）并配置颜色，灵活控制产物风格。",
		// academicTaskStep3Title: "配置信源与输出语言",
		// academicTaskStep3Desc: "在右侧面板中打开或关闭学术资源、文献库、网络资料，并可切换产物的输出语言（中文",
		// academicTaskStep4Title: "发送研究需求",
		// academicTaskStep4Desc: "确认内容无误后，点击右下角发送按钮，AI将立即开始处理您的请求并生成学术内容",
		// academicTaskStep5Title: "查看历史记录",
		// academicTaskStep5Desc: "点击左侧导航顶端的「历史记录」，可以查看您所有的历史研究记录，随时回溯并继续之前的研究方向",
		// academicTaskStep6Title: "使用预置指令快速启动",
		// academicTaskStep6Desc: "对话框下方展示了近期使用的预置指令，点击任意一条即可将其填入对话框，快速回复已有研究任务，无需重新输入，立即开始体验吧",
		// illustrationTaskStep1Title: "选择学术综述智能体",
		// illustrationTaskStep1Desc: "点击底部功能栏的「学术综述」按钮，选择您需要的智能体类型。除综述之外，还支持学术PPT、学术配图、学术海报等多种创作模式。",
		illustrationTaskStep2Title: "配置产物尺寸",
		illustrationTaskStep2Desc: "在左侧面板中选择产物尺寸",
		// illustrationTaskStep3Title: "配置信源与输出语言",
		// illustrationTaskStep3Desc: "在右侧面板中打开或关闭学术资源、文献库、网络资料，并可切换产物的输出语言（中文",
		// illustrationTaskStep4Title: "发送研究需求",
		// illustrationTaskStep4Desc: "确认内容无误后，点击右下角发送按钮，AI将立即开始处理您的请求并生成学术内容",
		// illustrationTaskStep5Title: "查看历史记录",
		// illustrationTaskStep5Desc: "点击左侧导航顶端的「历史记录」，可以查看您所有的历史研究记录，随时回溯并继续之前的研究方向",
		// illustrationTaskStep6Title: "使用预置指令快速启动",
		// illustrationTaskStep6Desc: "对话框下方展示了近期使用的预置指令，点击任意一条即可将其填入对话框，快速回复已有研究任务，无需重新输入，立即开始体验吧",
		// posterTaskStep1Title: "选择学术综述智能体",
		// posterTaskStep1Desc: "点击底部功能栏的「学术综述」按钮，选择您需要的智能体类型。除综述之外，还支持学术PPT、学术配图、学术海报等多种创作模式。",
		posterTaskStep2Title: "配置产物语言和颜色",
		posterTaskStep2Desc: "在左侧面板中切换输出语言（中文/EN）并配置颜色，灵活控制产物风格。",
		// posterTaskStep3Title: "配置信源与输出语言",
		// posterTaskStep3Desc: "在右侧面板中打开或关闭学术资源、文献库、网络资料，并可切换产物的输出语言（中文",
		// posterTaskStep4Title: "发送研究需求",
		// posterTaskStep4Desc: "确认内容无误后，点击右下角发送按钮，AI将立即开始处理您的请求并生成学术内容",
		// posterTaskStep5Title: "查看历史记录",
		// posterTaskStep5Desc: "点击左侧导航顶端的「历史记录」，可以查看您所有的历史研究记录，随时回溯并继续之前的研究方向",
		// posterTaskStep6Title: "使用预置指令快速启动",
		// posterTaskStep6Desc: "对话框下方展示了近期使用的预置指令，点击任意一条即可将其填入对话框，快速回复已有研究任务，无需重新输入，立即开始体验吧",
		// researchTaskStep1Title: "选择学术综述智能体",
		// researchTaskStep1Desc: "点击底部功能栏的「学术综述」按钮，选择您需要的智能体类型。除综述之外，还支持学术PPT、学术配图、学术海报等多种创作模式。",
		// researchTaskStep2Title: "输入您的研究需求",
		// researchTaskStep2Desc: "在对话框中用自然语言描述您的研究主题，可包含论文标题、关键词、内容描述等，AI将智能理解并生成对应内容。",
		// researchTaskStep3Title: "配置信源与输出语言",
		// researchTaskStep3Desc: "在右侧面板中打开或关闭学术资源、文献库、网络资料，并可切换产物的输出语言（中文",
		// researchTaskStep4Title: "发送研究需求",
		// researchTaskStep4Desc: "确认内容无误后，点击右下角发送按钮，AI将立即开始处理您的请求并生成学术内容",
		// researchTaskStep5Title: "查看历史记录",
		// researchTaskStep5Desc: "点击左侧导航顶端的「历史记录」，可以查看您所有的历史研究记录，随时回溯并继续之前的研究方向",
		// researchTaskStep6Title: "使用预置指令快速启动",
		// researchTaskStep6Desc: "对话框下方展示了近期使用的预置指令，点击任意一条即可将其填入对话框，快速回复已有研究任务，无需重新输入，立即开始体验吧",
		toolTaskStep1Title: '精选区域 - 高质量工具推荐',
		toolTaskStep1Desc: '精选区域为您推荐经过筛选的高质量科研工具，涵盖数据分析、可视化、文献管理等多个场景。点击「查看全部」可以浏览更多精选工具。',
		toolTaskStep2Title: '全部工具 - 筛选与搜索',
		toolTaskStep2Desc: '切换到「全部」标签页，可以查看所有可用的科研工具。支持按「热门」和「场景」进行筛选，也可以通过搜索框快速定位您需要的工具，提高查找效率。',
		toolTaskStep3Title: '我的工具 - 快速调用',
		toolTaskStep3Desc: '切换到「我的」标签页，可以查看您收藏的所有科研工具。收藏功能帮助您快速找到常用工具。',
		// toolTaskStep4Title: '特色智能体 - PDE-Agent',
		// toolTaskStep4Desc: 'PDE-Agent是我们的特色智能体工具，专门用于偏微分方程求解。您可以使用自然语言或LaTeX描述物理问题，系统会自动完成从解析、建模到求解的全流程，并支持思考过程可视化，让复杂的数学问题变得简单易懂。',
		toolTaskStep4Title: 'Banner区域 - 热门工具展示',
		toolTaskStep4Desc: 'Banner区域呈现当前最热门的科研工具，您可以直接体验工具功能、收藏感兴趣的工具、分享给同事，自研工具还提供GitHub开源入口，方便查看源代码和技术细节。',
		toolTaskStep5Title: '预置指令 - 快速开始',
		toolTaskStep5Desc: '点击预置指令可以快速填入常见的偏微分方程示例，如「二维纳维-斯托克斯方程」「Allen-Cahn方程」等，帮助您快速体验工具功能，无需手动输入复杂公式。',

	},
	docs:{
		termsofService: '服务协议',
		privacyPolicy:'隐私政策',
		institutionalAgreement: '机构账户激活&认证协议',
		coinRules:'研值规则',
	}
}
